export type ClientSupportedRuntimeEnv = Readonly<{
  DEFAULT_TIMEOUT_MSEC?: string;
  ENABLE_BUNDLE_BUILDER_EDD?: string;
  PUBLIC_PATH?: string;
  BUILD_VERSION?: string;
  DEPLOYMENT_ENV?: string;
  DEPLOYMENT_SLOT?: string;
  REGION_NAME?: string;
  NEXUS_CONTRACTS_BYPASS_STATUS?: string;
  NEXUS_CONTRACTS_BYPASS_DELETE?: string;
  NEXUS_CONTRACTS_BYPASS_RESEND?: string;
  NEXUS_CONTRACTS_BYPASS_SEND?: string;
  NEXUS_CONTRACTS_BYPASS_RECALL?: string;
  NEXUS_CONTRACTS_BYPASS_RECALL_AND_DELETE?: string;
}>;

// NOTE: Env variables on client side are only supported at compile time by
// default for RAZZLE_ prefixed variables, due to security concerns. To make any
// env variable available at runtime on the client, update this allow list
export const extractClientSupportedRuntimeEnv = (
  env: Dictionary<string | undefined>
): ClientSupportedRuntimeEnv => ({
  DEFAULT_TIMEOUT_MSEC: env.DEFAULT_TIMEOUT_MSEC,
  ENABLE_BUNDLE_BUILDER_EDD: env.ENABLE_BUNDLE_BUILDER_EDD,
  PUBLIC_PATH: env.PUBLIC_PATH,
  BUILD_VERSION: env.BUILD_VERSION,
  DEPLOYMENT_ENV: env.DEPLOYMENT_ENV,
  DEPLOYMENT_SLOT: env.DEPLOYMENT_SLOT,
  REGION_NAME: env.REGION_NAME,
  NEXUS_CONTRACTS_BYPASS_STATUS: env.NEXUS_CONTRACTS_BYPASS_STATUS,
  NEXUS_CONTRACTS_BYPASS_DELETE: env.NEXUS_CONTRACTS_BYPASS_DELETE,
  NEXUS_CONTRACTS_BYPASS_RESEND: env.NEXUS_CONTRACTS_BYPASS_RESEND,
  NEXUS_CONTRACTS_BYPASS_SEND: env.NEXUS_CONTRACTS_BYPASS_SEND,
  NEXUS_CONTRACTS_BYPASS_RECALL: env.NEXUS_CONTRACTS_BYPASS_RECALL,
  NEXUS_CONTRACTS_BYPASS_RECALL_AND_DELETE: env.NEXUS_CONTRACTS_BYPASS_RECALL_AND_DELETE,
});

export const isomorphicEnv: ClientSupportedRuntimeEnv =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  typeof window === "undefined" ? process.env : (window as any).env;
